<template lang="pug">
    v-snackbar.mb-3(
        auto-height
        small
        :bottom="!alignTop"
        :color="typeStyle.backColor"
        :timeout="timeoutState"
        :top="alignTop"
        v-model="vuexShow"
    )
        v-list.transparent( dark style='width:100%;' )
            v-list-tile.v-snackbar-tile
                v-list-tile-avatar
                    v-icon( color='white' large v-if="typeStyle" ) {{ typeStyle.leftIcon }}
                v-list-tile-content
                    v-list-tile-title( v-if="message.title" ) {{ message.title }}
                    v-list-tile-sub-title {{ message.body }}
                v-list-tile-action
                    v-btn( 
                        :color="typeStyle.backColor.split(' ').shift() + ' darken-4'" 
                        v-if="enableConfirm" 
                        @click="confirmAction(messageConfirm)" 
                        ) {{ messageConfirm }}
                    v-btn( 
                        :color="typeStyle.backColor"
                        v-if="closeOptions.show" 
                        @click='hideSnack'
                        ).ml-3 {{ closeOptions.text }}
        //v-container( pb-3 px-0 )
            v-layout( row wrap )
                v-flex( 
                    :xs6="enableConfirm" 
                    :xs9="!enableConfirm" 
                )
                    v-container( fluid pa-0 grid-list-xs )
                        v-layout( row )
                            v-flex( xs2 )
                                v-icon.my-1( color='white' large v-if="typeStyle" ) {{ typeStyle.leftIcon }}
                            v-flex( xs10 )
                                h1.d-inline.subheading.font-weight-normal( v-if="message.title" ) {{ message.title }}
                v-flex( xs text-xs-right )
                    v-btn.mx-2( 
                        :color="typeStyle.backColor.split(' ').shift() + ' darken-4'"                       
                        v-if="enableConfirm"   
                        @click="confirmAction(messageConfirm)" 
                    ) {{ messageConfirm }}
                    v-btn.ma-0( 
                        :color="typeStyle.backColor"
                        v-if="closeOptions.show" 
                         
                        @click="hideSnack"
                    ) {{ closeOptions.text }}
                v-flex( xs12 )
                    p.ml-3.my-2.pl-4.pt-2( style="font-size:14px;line-height:1.5;white-space:pre-line" ) {{ message.body }}
        v-spacer
        div
            v-progress-circular(v-if="showProgress" indeterminate size='30' ma-10)

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'snackbar-modal',
    data() {
        return {
            show: false,
            tout: false,
        }
    },


    computed: {
        ...mapState('SnackbarModalModule', {
            typeMessage: state => state.typeMessage, //success | warning | info | error,
            showSnack: state => state.showSnack,
            showProgress: state => state.showProgress,
            timeoutState: state => state.timeout,
            closeOptions: state => state.closeOptions, // {text: 'close', show: false}
            message: state => state.message, // {title: '', body: ''}
            enableConfirm: state=>state.enableConfirm,
            messageConfirm: state=>state.messageConfirm,
            alignTop: 'alignTop',
        }),

        /**
         * @description
         */
        vuexShow: {
            get: function(){
                return this.showSnack
            },
            set: function(newVal){
                if(!newVal){
                    this.resetSnackbarState()
                }
                return newVal

            }
        },
        ...mapGetters('SnackbarModalModule', {
            typeStyle: 'typeStyle',
        }),

        // show() {
        //     return this.showSnackbar
        // }


    },

    methods: {
        ...mapActions('SnackbarModalModule', {
            //initSnackbar:       'initSnackbar',
            //setType:    'setType',
            hideSnack: 'hideSnack',
            //showSnack:  'showSnack',
            responseConfirm : 'responseConfirm',
            resetSnackbarState: 'resetSnackbarState',
            //showClose:  'showClose',
            //hideClose:  'hideClose',
        }),
        confirmAction(identifierAction){
            this.responseConfirm(identifierAction)
        }

    },

    watch: {
        // /**
        //  * @description
        //  */
        // showSnack(newVal, oldVal) {
        //     //this.show = false
        //     // console.log("showSnackbar:")
        //     // console.log(this.showSnackbar)
        //     console.log('showSnack updated to', newVal)
        //     this.show = newVal
        // },

        /**
         * @description
         */
        timeoutState(newVal, oldVal) {
            this.tout = newVal
        }
    }

    // created: function() {
    //     this.$store.watch(
    //         state => state.snackbar.snack,
    //         () => {
    //             const msg = this.$store.state.snackbar.snack
    //             if (msg !== '') {
    //                 this.show = true
    //                 this.message = this.$store.state.snackbar.snack
    //                 this.$store.commit('snackbar/setSnack', '')
    //             }
    //         }
    //     )
    // },
}
</script>

<style>
/* .danger {
    background-color: red !important;
    border-color: red !important;
} */

.v-snackbar-tile .v-list__tile {
    padding: 0 !important;
}

.v-snackbar-tile > .v-list__tile, 
.v-snackbar-tile > .v-list__tile .v-list__tile__title {
    height: auto !important;
}

.v-snackbar-tile .v-list__tile__sub-title, 
.v-snackbar-tile .v-list__tile__title {
    text-overflow: unset !important; 
    white-space: normal !important;
}

.v-snackbar-tile .v-list__tile__action {
    display: inline-block !important;
}

@media only screen and (min-width: 600px){
    .v-snack__wrapper {
        width: auto;
        max-width: 668px;
        min-width: 288px;
        margin: 0 auto;
        border-radius: 2px;
    }
}
</style>